import React from 'react'
import PropTypes from 'prop-types'
import IconTextInput from '../IconTextInput'
import { Icon } from '@maui/elements'

function SearchInput({ placeholder = 'Search', ...props }) {
  return (
    <IconTextInput
      leftIcon={<Icon name="search" />}
      type="search"
      placeholder={placeholder}
      {...props}
    />
  )
}

SearchInput.propTypes = {
  placeholder: PropTypes.string,
}

export default SearchInput
